/* CREST — criterio di ricerca condiviso */
(function () {
  'use strict';

  if (window.CrestSearchCore) return;

  const aliases = {
    cere: 'cera',
    opaca: 'opaco',
    opache: 'opaco',
    opachi: 'opaco',
    lucida: 'lucido',
    lucide: 'lucido',
    lucidi: 'lucido',
    anticrespo: 'crespo',
    idratanti: 'idratante',
    shampooing: 'shampoo',
    beard: 'barba',
    hair: 'capelli'
  };

  const stops = new Set([
    'di', 'da', 'del', 'della', 'dei', 'delle',
    'per', 'con', 'e', 'il', 'lo', 'la', 'i',
    'gli', 'le', 'un', 'una', 'uno', 'crest'
  ]);

  const normalize = value => String(value || '')
    .trim()
    .toLocaleLowerCase('it')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/anti[ -]crespo/g, 'anticrespo')
    .replace(/(\d)\s*(litro|litri|l)\b/g, '$1l')
    .replace(/(\d)\s*(ml|cl)\b/g, '$1$2')
    .replace(/\b1000ml\b/g, '1l')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const tokens = value => normalize(value)
    .split(/\s+/)
    .filter(Boolean)
    .map(word => aliases[word] || word)
    .filter(word => !stops.has(word));

  const groups = {
    rasatura: [
      'rasatura', 'creme-da-rasatura',
      'gel-da-rasatura', 'dopo-barba'
    ],
    barba: [
      'prodotti-barba', 'oli-da-barba',
      'shampoo-balsamo-barba', 'cera-baffi'
    ],
    cere: ['cere-per-capelli'],
    styling: [
      'hair-gel', 'hair-spray-mousse',
      'spray-volumizzanti', 'styling-veloce'
    ],
    capelli: [
      'cura-dei-capelli', 'shampoo-capelli',
      'trattamenti-capelli', 'lozioni-capelli'
    ]
  };

  function category(product) {
    const value = normalize(product.category);

    if (Object.hasOwn(groups, value)) return value;

    return Object.keys(groups).find(key =>
      groups[key].some(handle =>
        (product.collections || []).includes(handle)
      )
    ) || '';
  }

  const typeLabels = {
    'cere-per-capelli': 'Cera',
    'hair-gel': 'Gel',
    'hair-spray-mousse': 'Spray e mousse',
    'spray-volumizzanti': 'Spray',
    'styling-veloce': 'Crema e fluido styling',
    'shampoo-capelli': 'Shampoo',
    'trattamenti-capelli': 'Trattamento',
    'lozioni-capelli': 'Lozione',
    'oli-da-barba': 'Olio barba',
    'shampoo-balsamo-barba': 'Shampoo e balsamo barba',
    'cera-baffi': 'Cera baffi',
    'creme-da-rasatura': 'Crema da rasatura',
    'gel-da-rasatura': 'Gel da rasatura',
    'dopo-barba': 'Dopobarba'
  };

  function type(product) {
    return product.type ||
      Object.keys(typeLabels)
        .filter(key =>
          (product.collections || []).includes(key)
        )
        .map(key => typeLabels[key])[0] ||
      product.productType ||
      '';
  }

  function score(product, query) {
    const wanted = [...new Set(tokens(query))];

    if (!wanted.length) return 0;

    const fields = [
      [product.title, 50],
      [product.short, 45],
      [product.type || product.tipologia, 25],
      [product.category, 20],
      [product.benefit || product.beneficio, 15],
      [product.hold || product.tenuta, 10],
      [product.finish, 10],
      [(product.variants || []).map(v => v.title).join(' '), 5]
    ].map(([text, weight]) => ({
      words: tokens(text),
      weight
    }));

    let total = 0;

    for (const word of wanted) {
      let best = -1;

      for (const field of fields) {
        if (field.words.includes(word)) {
          best = Math.max(best, field.weight);
        } else if (
          word.length >= 3 &&
          field.words.some(value => value.startsWith(word))
        ) {
          best = Math.max(best, field.weight / 2);
        }
      }

      if (best < 0) return -1;
      total += best;
    }

    const phrase = wanted.join(' ');

    if (tokens(product.title).join(' ').includes(phrase)) {
      total += 30;
    }

    return total;
  }

  window.CrestSearchCore = Object.freeze({
    normalize,
    tokens,
    category,
    type,
    score
  });
})();

/* CREST — selettori varianti della griglia condivisi */
(function () {
  'use strict';

  if (customElements.get('crest-grid-variant-select')) return;

  customElements.define(
    'crest-grid-variant-select',
    class extends HTMLElement {
      connectedCallback() {
        if (this.onChange) return;

        this.select = this.querySelector('select');
        this.productForm = this.closest('crest-grid-cart');
        this.card = this.closest('.crest-product-card');
        this.button = this.productForm.querySelector('[type="submit"]');
        this.input = this.productForm.querySelector('input[name="id"]');

        this.pillGroup = document.createElement('div');
        this.pillGroup.className = 'crest-product-card__variant-options';
        this.pillGroup.setAttribute('role', 'group');
        this.pillGroup.setAttribute(
          'aria-label',
          this.select.getAttribute('aria-label') || 'Scegli la variante'
        );

        this.pills = Array.from(this.select.options).map(option => {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'crest-product-card__variant-pill';
          pill.value = option.value;
          pill.textContent = option.textContent.trim()
            .replace(/\s+/g, ' ')
            .replace(/(\d)(ml|cl|l)\b/gi, '$1 $2');
          pill.setAttribute('data-crest-variant-id', option.value);
          this.pillGroup.appendChild(pill);
          return { pill, option };
        });

        this.onPick = event => {
          const pill = event.target.closest(
            'button[data-crest-variant-id]'
          );

          if (
            !pill ||
            !this.pillGroup.contains(pill) ||
            pill.disabled ||
            this.button.classList.contains('loading') ||
            pill.value === this.select.value
          ) return;

          this.select.value = pill.value;
          this.select.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        };

        this.pillGroup.addEventListener('click', this.onPick);
        this.select.before(this.pillGroup);
        this.select.hidden = true;

        this.label = this.querySelector('label');
        if (this.label) this.label.textContent = 'Formato / variante';

        this.onChange = () => this.updateVariant();
        this.select.addEventListener('change', this.onChange);

        this.onSubmit = event => {
          const option = this.select.selectedOptions[0];

          if (!option || option.dataset.available !== 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };

        this.form = this.closest('form');
        this.form.addEventListener('submit', this.onSubmit, true);

        this.observer = new MutationObserver(() => {
          this.select.disabled =
            this.button.classList.contains('loading');
          this.updatePills();
        });

        this.observer.observe(this.button, {
          attributes: true,
          attributeFilter: ['class']
        });

        this.updateVariant();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();

        if (this.select && this.onChange) {
          this.select.removeEventListener('change', this.onChange);
        }

        if (this.form && this.onSubmit) {
          this.form.removeEventListener('submit', this.onSubmit, true);
        }

        if (this.pillGroup) {
          this.pillGroup.removeEventListener('click', this.onPick);
          this.pillGroup.remove();
        }

        if (this.select) this.select.hidden = false;
        this.onChange = null;
      }

      updatePills() {
        const loading = this.button.classList.contains('loading');

        this.pills.forEach(({ pill, option }) => {
          pill.setAttribute(
            'aria-pressed',
            String(option.value === this.select.value)
          );

          pill.disabled =
            loading || option.dataset.available !== 'true';

          pill.classList.toggle(
            'is-unavailable',
            option.dataset.available !== 'true'
          );
        });
      }

      updateVariant() {
        if (this.button.classList.contains('loading')) return;

        const option = this.select.selectedOptions[0];
        if (!option) return;

        const available = option.dataset.available === 'true';
        const sale =
          Number(option.dataset.compare) > Number(option.dataset.price);

        this.input.value = option.value;
        this.button.disabled = !available;
        this.button.removeAttribute('aria-disabled');
        this.button.querySelector('span').textContent = available
          ? 'Aggiungi al carrello'
          : 'Esaurito';

        if (typeof this.productForm.handleErrorMessage === 'function') {
          this.productForm.handleErrorMessage();
        }

        const price = this.card.querySelector(
          '[data-crest-card-price] .price'
        );

        if (price) {
          price.classList.toggle('price--on-sale', sale);
          price.classList.toggle('price--sold-out', !available);
          price.classList.remove('price--no-compare');

          const regular = price.querySelector(
            '.price__regular .price-item--regular'
          );

          let compare = price.querySelector(
            '.price__sale .price-item--regular'
          );

          const current = price.querySelector(
            '.price__sale .price-item--sale'
          );

          if (sale && !compare) {
            const saleGroup = price.querySelector('.price__sale');

            if (saleGroup) {
              compare = document.createElement('s');
              compare.className = 'price-item price-item--regular';
              saleGroup.prepend(compare);
            }
          }

          if (regular) regular.textContent = option.dataset.money;

          if (compare) {
            compare.textContent = sale
              ? option.dataset.compareMoney
              : '';
          }

          if (current) current.textContent = option.dataset.money;

          const oldUnit = price.querySelector('.unit-price');
          if (oldUnit) oldUnit.remove();

          const unitTemplate = Array.from(
            this.querySelectorAll('template[data-crest-unit-price]')
          ).find(template =>
            template.dataset.crestUnitPrice === option.value
          );

          const container = price.querySelector('.price__container');

          if (unitTemplate && container) {
            container.appendChild(
              unitTemplate.content.cloneNode(true)
            );
          }
        }

        const badge = this.card.querySelector(
          '[data-crest-variant-badge]'
        );

        if (badge) {
          badge.hidden = available && !sale;
          badge.textContent = available ? 'In offerta' : 'Esaurito';
          badge.classList.toggle(
            'crest-product-card__badge--sale',
            available && sale
          );
        }

        this.updatePills();
      }
    }
  );
})();

/* CREST — unico controller per le form crest-grid-cart */
(function () {
  if (window.crestGridCartV8Ready) return;
  window.crestGridCartV8Ready = true;

  const gridStates = new Map();
  let gridCart = null;
  let gridReadVersion = 0;
  let gridReadTimer = null;
  let gridQueue = Promise.resolve();
  let gridMutating = false;

  function gridState(form) {
    if (!gridStates.has(form)) {
      gridStates.set(form, {
        busy: false,
        timer: null,
        kind: '',
        receipt: ''
      });
    }
    return gridStates.get(form);
  }

  function gridVariant(form) {
    return String(form.querySelector('[name="id"]')?.value || '');
  }

  function gridLines(cart, variantId) {
    return (cart?.items || []).filter(item =>
      String(item.variant_id) === String(variantId) &&
      !item.selling_plan_allocation &&
      !Object.keys(item.properties || {}).length
    );
  }

  function clearGridFeedback(form) {
    const state = gridState(form);
    clearTimeout(state.timer);
    state.timer = null;
    state.kind = '';
    state.receipt = '';

    const feedback = form.querySelector('.crest-grid-cart__feedback');
    feedback.hidden = true;
    feedback.textContent = '';
  }

  function showGridFeedback(form, message, success, variantId) {
    clearGridFeedback(form);

    const state = gridState(form);
    const feedback = form.querySelector('.crest-grid-cart__feedback');

    state.kind = success ? 'success' : 'error';
    state.receipt = String(variantId || '');
    feedback.classList.toggle('visually-hidden', success);
    feedback.textContent = message;
    feedback.hidden = false;

    if (success) {
      state.timer = setTimeout(() => {
        clearGridFeedback(form);
        if (!form.isConnected) gridStates.delete(form);
      }, 3000);
    }
  }

  function syncGridForm(form) {
    const state = gridState(form);
    const id = gridVariant(form);
    const quantity = form.querySelector('[data-crest-quantity]');

    const count = gridCart
      ? gridLines(gridCart, id).reduce(
          (sum, item) => sum + Number(item.quantity || 0),
          0
        )
      : 0;

    const status = form.querySelector('[data-crest-cart-count]');
    const remove = form.querySelector('[data-crest-remove]');

    status.hidden = count === 0;
    status.textContent = count ? 'Nel carrello: ' + count + ' pz' : '';
    remove.hidden = count === 0;
    remove.disabled = state.busy || count === 0;

    const option = form.querySelector(
      '.crest-product-card__variant-select'
    )?.selectedOptions[0];

    const available = !option || option.dataset.available === 'true';
    const add = form.querySelector('[type="submit"]');

    add.classList.toggle('loading', state.busy);

    form.querySelectorAll(
      '.crest-product-card__button, .crest-product-card__variant-select, [data-crest-quantity]'
    ).forEach(control => {
      control.disabled = state.busy;
    });

    add.disabled = state.busy || !available;

    if (!state.busy) {
      add.querySelector('span').textContent = available
        ? 'Aggiungi al carrello'
        : 'Esaurito';
    }

    form.querySelector('[data-crest-qty-minus]').disabled =
      state.busy || Number(quantity.value) <= 1;

    form.querySelector('[data-crest-qty-plus]').disabled =
      state.busy || Number(quantity.value) >= 99;

    if (
      state.kind === 'success' &&
      (
        state.receipt !== id ||
        (gridCart && count === 0)
      )
    ) clearGridFeedback(form);
  }

  function syncGridForms() {
    gridStates.forEach((state, form) => {
      if (!form.isConnected) {
        clearTimeout(state.timer);
        gridStates.delete(form);
      }
    });

    document.querySelectorAll(
      'crest-grid-cart .crest-grid-cart-form'
    ).forEach(syncGridForm);
  }

  function acceptGridCart(cart) {
    if (
      !Array.isArray(cart?.items) ||
      !Number.isFinite(cart.item_count)
    ) return;

    gridCart = cart;
    syncGridForms();
  }

  async function fetchGridCart() {
    const response = await fetch(
      (window.Shopify?.routes?.root || '/') + 'cart.js',
      {
        credentials: 'same-origin',
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error('Impossibile leggere il carrello. Riprova.');
    }

    const cart = await response.json();

    if (
      !Array.isArray(cart.items) ||
      !Number.isFinite(cart.item_count)
    ) {
      throw new Error('Risposta del carrello non valida. Riprova.');
    }

    return cart;
  }

  async function refreshGridCart() {
    if (gridMutating) return;

    const version = ++gridReadVersion;

    try {
      const cart = await fetchGridCart();

      if (version === gridReadVersion && !gridMutating) {
        acceptGridCart(cart);
      }
    } catch (error) {
      console.warn('CREST griglia: aggiornamento carrello', error);
    }
  }

  function scheduleGridCart() {
    gridReadVersion += 1;
    clearTimeout(gridReadTimer);

    if (gridMutating) return;
    gridReadTimer = setTimeout(refreshGridCart, 80);
  }

  function gridCartEvent(event) {
    gridReadVersion += 1;
    const cart = event?.detail?.cart || event?.cartData;

    if (
      !gridMutating &&
      Array.isArray(cart?.items) &&
      Number.isFinite(cart.item_count)
    ) {
      acceptGridCart(cart);
    } else {
      scheduleGridCart();
    }
  }

  function gridSections() {
    const ui =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    const descriptors =
      ui && typeof ui.getSectionsToRender === 'function'
        ? ui.getSectionsToRender()
        : [];

    const ids = Array.from(
      new Set(
        ['cart-icon-bubble'].concat(
          descriptors.map(section => section.id).filter(Boolean)
        )
      )
    ).slice(0, 5);

    return { ui, descriptors, ids };
  }

  function renderGridSections(result, sections, openDrawer) {
    if (
      openDrawer &&
      sections.ui &&
      typeof sections.ui.renderContents === 'function' &&
      result.sections
    ) {
      try {
        sections.ui.classList.remove('is-empty');
        sections.ui.renderContents(result);
        return;
      } catch (error) {
        console.warn('Aggiornamento carrello:', error);
      }
    }

    sections.descriptors.concat([
      { id: 'cart-icon-bubble' }
    ]).forEach(section => {
      const html = result.sections?.[section.id];
      if (typeof html !== 'string' || !html.trim()) return;

      const selector = section.selector || '#' + section.id;
      const target = document.querySelector(selector);
      if (!target) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source =
        parsed.querySelector(selector) ||
        parsed.getElementById('shopify-section-' + section.id);

      if (source) target.innerHTML = source.innerHTML;
    });

    const drawer = document.querySelector('cart-drawer');

    if (drawer && Number.isFinite(result.item_count)) {
      drawer.classList.toggle('is-empty', result.item_count === 0);
    }
  }

  function notifyGridCart(cart) {
    document.dispatchEvent(
      new CustomEvent('crest-pairings:cart-changed', {
        detail: { cart }
      })
    );

    if (
      typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'crest-grid',
        cartData: cart
      });
    }
  }

  function runGridMutation(task) {
    const result = gridQueue.then(async () => {
      gridMutating = true;
      gridReadVersion += 1;
      clearTimeout(gridReadTimer);

      try {
        return await task();
      } finally {
        gridMutating = false;
        scheduleGridCart();
      }
    });

    gridQueue = result.catch(() => {});
    return result;
  }

  async function removeGridVariant(form, variantId) {
    const sections = gridSections();
    let cart = await fetchGridCart();
    let attempts = 0;
    const removedItems = [];

    while (gridLines(cart, variantId).length && attempts < 50) {
      const item = gridLines(cart, variantId)[0];

      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/change.js',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: sections.ids,
            sections_url: window.location.pathname
          })
        }
      );

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'Rimozione non riuscita. Riprova.'
        );
      }

      if (!Array.isArray(result.items) || !Number.isFinite(result.item_count)) {
        throw new Error('Risposta del carrello incompleta. Verifica prima di riprovare.');
      }

      if (!result.items.some(entry => entry.key === item.key)) {
        removedItems.push(item);
      }

      cart = result;
      attempts += 1;
    }

    gridReadVersion += 1;
    acceptGridCart(cart);
    renderGridSections(cart, sections, false);
    notifyGridCart(cart);

    if (gridLines(cart, variantId).length) {
      throw new Error('Rimozione parziale: verifica il carrello.');
    }

    try {
      window.CrestSavedToast?.showRemoved?.(
        removedItems,
        form.querySelector('[type="submit"]')
      );
    } catch (_) {}
  }

  document.addEventListener('change', event => {
    const form = event.target.closest?.(
      'crest-grid-cart .crest-grid-cart-form'
    );

    if (!form) return;

    if (event.target.matches('.crest-product-card__variant-select')) {
      clearGridFeedback(form);
      syncGridForm(form);
      scheduleGridCart();
    } else if (event.target.matches('[data-crest-quantity]')) {
      if (event.target.checkValidity()) syncGridForm(form);
    }
  });

  document.addEventListener('click', async event => {
    const control = event.target.closest?.(
      '[data-crest-qty-minus], [data-crest-qty-plus], [data-crest-remove]'
    );

    const form = control?.closest(
      'crest-grid-cart .crest-grid-cart-form'
    );

    if (!form || gridState(form).busy || control.disabled) return;

    const quantity = form.querySelector('[data-crest-quantity]');

    if (!control.matches('[data-crest-remove]')) {
      const delta = control.matches('[data-crest-qty-plus]') ? 1 : -1;

      quantity.value = String(
        Math.max(1, Math.min(99, (Number(quantity.value) || 1) + delta))
      );

      syncGridForm(form);
      return;
    }

    const state = gridState(form);
    const variantId = gridVariant(form);

    state.busy = true;
    clearGridFeedback(form);
    form.setAttribute('aria-busy', 'true');
    syncGridForm(form);

    try {
      await runGridMutation(() =>
        removeGridVariant(form, variantId)
      );
    } catch (error) {
      showGridFeedback(
        form,
        error.message || 'Rimozione non riuscita. Riprova.',
        false
      );
    } finally {
      state.busy = false;
      form.removeAttribute('aria-busy');
      syncGridForm(form);
    }
  });

  document.addEventListener('submit', async event => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      !form.matches('crest-grid-cart .crest-grid-cart-form')
    ) return;

    event.preventDefault();

    const state = gridState(form);
    if (state.busy) return;

    const option = form.querySelector(
      '.crest-product-card__variant-select'
    )?.selectedOptions[0];

    if (option && option.dataset.available !== 'true') return;

    const quantity = form.querySelector('[data-crest-quantity]');
    if (!quantity.reportValidity()) return;

    const variantId = gridVariant(form);
    const amount = quantity.value;
    const card = form.closest('.crest-product-card');

    const cardImage = card?.querySelector(
      '.crest-product-card__image,.cs-image img'
    );

    const receipt = {
      title: card?.querySelector(
        '.crest-product-card__title a,.cs-info h3 a'
      )?.textContent.trim() || '',
      format: option?.textContent.trim() || '',
      image:
        cardImage?.currentSrc ||
        cardImage?.getAttribute('src') ||
        '',
      quantity: Number(amount)
    };

    const formData = new FormData(form);

    formData.set('id', variantId);
    formData.set('quantity', amount);

    const button = form.querySelector('.crest-product-card__button');
    const buttonText = button.querySelector('span');

    state.busy = true;
    clearGridFeedback(form);
    form.setAttribute('aria-busy', 'true');
    buttonText.textContent = 'Aggiungo…';
    syncGridForm(form);

    try {
      await runGridMutation(async () => {
        const sections = gridSections();

        formData.set('sections', sections.ids.join(','));
        formData.set('sections_url', window.location.pathname);

        if (
          sections.ui &&
          typeof sections.ui.setActiveElement === 'function'
        ) {
          sections.ui.setActiveElement(button);
        }

        const response = await fetch(
          form.getAttribute('action').replace(/\/$/, '') + '.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            },
            body: formData
          }
        );

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
            result.message ||
            'Errore carrello'
          );
        }

        gridCart = null;

        renderGridSections(
          result,
          sections,
          !form.hasAttribute('data-crest-search-cart')
        );

        try {
          const cart = await fetchGridCart();
          gridReadVersion += 1;
          acceptGridCart(cart);
          notifyGridCart(cart);
        } catch (readError) {
          console.warn(
            'CREST griglia: rilettura dopo aggiunta',
            readError
          );
        }

        receipt.title ||=
          result.product_title || result.title || 'Prodotto';

        receipt.format ||= result.variant_title === 'Default Title'
          ? ''
          : result.variant_title || '';

        receipt.image =
          result.featured_image?.url ||
          result.image ||
          receipt.image;

        let notified = false;

        try {
          if (window.CrestSavedToast?.show) {
            window.CrestSavedToast.show(receipt, {
              kind: 'cart',
              invoker: button
            });

            notified = true;
          }
        } catch (toastError) {
          console.warn('CREST notifica carrello:', toastError);
        }

        if (
          !notified &&
          form.isConnected &&
          gridVariant(form) === variantId
        ) {
          showGridFeedback(
            form,
            receipt.quantity + ' pz aggiunti al carrello: ' +
              receipt.title,
            true,
            variantId
          );
        }
      });
    } catch (error) {
      console.error('Aggiunta al carrello:', error);

      showGridFeedback(
        form,
        error.message ||
        'Non è stato possibile aggiungere il prodotto. Riprova.',
        false
      );
    } finally {
      state.busy = false;
      buttonText.textContent = 'Aggiungi al carrello';
      form.removeAttribute('aria-busy');
      syncGridForm(form);
    }
  });

  function initGridCart() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, gridCartEvent);
    }

    const observer = new MutationObserver(scheduleGridCart);

    document.querySelectorAll(
      'cart-drawer, cart-notification, cart-items'
    ).forEach(target => {
      observer.observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    refreshGridCart();
  }

  document.addEventListener(
    'crest-pairings:cart-changed',
    gridCartEvent
  );

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleGridCart();
  });

  window.addEventListener('focus', scheduleGridCart);
  window.addEventListener('pageshow', scheduleGridCart);

  document.addEventListener('shopify:section:load', () => {
    syncGridForms();
    scheduleGridCart();
  });

  document.addEventListener('shopify:section:unload', event => {
    gridStates.forEach((state, form) => {
      if (event.target.contains(form)) {
        clearTimeout(state.timer);
        gridStates.delete(form);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridCart, {
      once: true
    });
  } else {
    initGridCart();
  }
})();

/* CREST — pannello ricerca Compatta */
(function () {
  'use strict';

  if (window.crestCompactSearchReady) return;

  const root = document.getElementById('CrestSearch');
  const configNode = document.getElementById('CrestSearchConfig');

  if (!root || !configNode) return;
  window.crestCompactSearchReady = true;

  const config = JSON.parse(configNode.textContent);
  const core = window.CrestSearchCore;
  const panel = root.querySelector('.cs-panel');
  const input = root.querySelector('input');
  const results = root.querySelector('.cs-results');
  const status = root.querySelector('[data-cs-status]');
  const all = root.querySelector('[data-cs-all]');
  const retry = root.querySelector('[data-cs-retry]');
  const cards = new Map();

  let catalog = null;
  let loadedAt = 0;
  let pending = null;
  let failed = false;
  let opener;
  let pageX = 0;
  let pageY = 0;
  let overflow = '';
  let inerted = [];
  let timer;
  let drawVersion = 0;

  const escape = value => String(value ?? '').replace(
    /[&<>"']/g,
    char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char])
  );

  function safeURL(value, image = false) {
    if (!value) return '';

    const url = new URL(value, location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return '';

    return url.origin === location.origin ||
      (image && url.hostname === 'cdn.shopify.com')
      ? url.href
      : '';
  }

  function destination(query) {
    const url = new URL(config.collection, location.origin);
    url.searchParams.set('crest_q', query.trim().slice(0, 160));
    url.hash = 'ProductGridContainer';
    return url.href;
  }

  if (config.searchPage) {
    location.replace(
      destination(
        new URL(location.href).searchParams.get('q') ||
        config.terms ||
        ''
      )
    );
    return;
  }

  const busy = () => Boolean(
    results.querySelector('form[aria-busy="true"]')
  );

  function updateLink() {
    all.href = destination(input.value);
    all.setAttribute('aria-disabled', String(busy()));
  }

  async function loadCatalog() {
    if (catalog && Date.now() - loadedAt < 60000) return catalog;
    if (pending) return pending;

    pending = (async () => {
      const products = new Map();
      let pages = 1;
      let expected = null;

      for (let page = 1; page <= pages; page++) {
        const url = new URL(config.collection, location.origin);
        url.searchParams.set('section_id', 'crest-search-data');
        url.searchParams.set('page', String(page));

        const preview = new URL(location.href)
          .searchParams.get('preview_theme_id');

        if (preview) url.searchParams.set('preview_theme_id', preview);

        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        let html;

        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: controller.signal
          });

          if (!response.ok) {
            throw Error('Caricamento del catalogo non riuscito.');
          }

          html = await response.text();
        } finally {
          clearTimeout(timeout);
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const node = doc.querySelector('[data-crest-search-data]');

        if (!node) {
          throw Error(
            'La sezione crest-search-data non è disponibile nel tema.'
          );
        }

        const data = JSON.parse(node.textContent);

        if (
          !Array.isArray(data.products) ||
          Number(data.page) !== page ||
          !Number.isInteger(data.pages) ||
          data.pages < 0 ||
          data.pages > 500 ||
          !Number.isInteger(data.total)
        ) {
          throw Error('Catalogo incompleto. Riprova.');
        }

        if (expected !== null && expected !== data.total) {
          throw Error(
            'Il catalogo è cambiato durante il caricamento. Riprova.'
          );
        }

        pages = Math.max(1, data.pages);
        expected = data.total;

        for (const product of data.products) {
          if (
            !product.id ||
            !Array.isArray(product.variants) ||
            !product.variants.length ||
            !safeURL(product.url)
          ) {
            throw Error('Dati prodotto incompleti. Riprova.');
          }

          product.category = core.category(product);
          product.type = core.type(product);
          products.set(String(product.id), product);
        }
      }

      if (products.size !== expected) {
        throw Error(
          'Non sono stati caricati tutti i prodotti. Riprova.'
        );
      }

      catalog = [...products.values()];
      loadedAt = Date.now();
      failed = false;

      cards.forEach(card => {
        if (!card.isConnected) {
          cards.delete(card.dataset.productId);
        }
      });

      return catalog;
    })().finally(() => {
      pending = null;
    });

    return pending;
  }

  function cardFor(p) {
    const previous = cards.get(p.id);

    if (
      previous &&
      previous.dataset.loadedAt === String(loadedAt)
    ) return previous;

    const v =
      p.variants.find(variant => variant.id === p.initial) ||
      p.variants[0];

    const fid = 'crest-search-product-' + p.id;
    const image = safeURL(p.image, true);
    const saved = JSON.stringify(p).replace(/</g, '\\u003c');
    const sale = Number(v.compare) > Number(v.price);

    const heart = `
      <crest-save-card hidden>
        <script type="application/json" data-card-saved-data>${saved}</script>
        <button
          type="button"
          class="crest-card-save"
          disabled
          aria-pressed="false"
          aria-label="Salva per dopo ${escape(p.short)}"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            aria-hidden="true"
          >
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/>
          </svg>
        </button>
      </crest-save-card>
    `;

    const picker = p.variants.length > 1 ? `
      <crest-grid-variant-select>
        <label class="visually-hidden" for="${fid}-variant">
          Formato
        </label>
        <select
          id="${fid}-variant"
          class="crest-product-card__variant-select"
          aria-label="Formato di ${escape(p.short)}"
        >
          ${p.variants.map(option => `
            <option
              value="${escape(option.id)}"
              data-available="${Boolean(option.available)}"
              data-price="${Number(option.price)}"
              data-compare="${Number(option.compare)}"
              data-money="${escape(option.money)}"
              data-compare-money="${escape(option.compareMoney)}"
              ${option.id === v.id ? 'selected' : ''}
            >${escape(option.title)}${option.available ? '' : ' — Esaurito'}</option>
          `).join('')}
        </select>
      </crest-grid-variant-select>
    ` : '';

    const price = `
      <div class="cs-price" data-crest-card-price>
        <div class="price ${sale ? 'price--on-sale' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="price-item--regular">
                ${escape(v.money)}
              </span>
            </div>
            <div class="price__sale">
              <s class="price-item--regular">
                ${sale ? escape(v.compareMoney) : ''}
              </s>
              <span class="price-item--sale">
                ${escape(v.money)}
              </span>
            </div>
          </div>
        </div>
      </div>
    `;

    let purchase;

    if (!p.available) {
      purchase = price + '<span class="cs-unavailable">Esaurito</span>';
    } else if (p.complex) {
      purchase = price + `
        <a class="cs-details" href="${escape(safeURL(p.url))}">
          Scegli nella scheda →
        </a>
      `;
    } else {
      purchase = `
        <crest-grid-cart>
          <form
            action="${escape(config.add)}"
            method="post"
            class="crest-grid-cart-form"
            data-crest-search-cart
            novalidate
          >
            ${price}
            ${picker}

            <input type="hidden" name="id" value="${escape(v.id)}">

            <div
              class="crest-grid-cart__quantity"
              role="group"
              aria-label="Quantità da aggiungere di ${escape(p.short)}"
            >
              <button
                type="button"
                data-crest-qty-minus
                aria-label="Diminuisci quantità"
                disabled
              >−</button>

              <input
                type="number"
                name="quantity"
                value="1"
                min="1"
                max="99"
                step="1"
                inputmode="numeric"
                required
                data-crest-quantity
                aria-label="Quantità da aggiungere"
              >

              <button
                type="button"
                data-crest-qty-plus
                aria-label="Aumenta quantità"
              >+</button>
            </div>

            <button type="submit" class="crest-product-card__button">
              <span>Aggiungi al carrello</span>
            </button>

            <span
              class="crest-grid-cart__count"
              data-crest-cart-count
              role="status"
              hidden
            ></span>

            <button
              type="button"
              class="crest-grid-cart__remove"
              data-crest-remove
              hidden
              aria-label="Rimuovi tutte le unità del formato selezionato di ${escape(p.short)}"
            >Rimuovi</button>

            <span
              class="crest-grid-cart__feedback"
              role="status"
              hidden
            ></span>
          </form>
        </crest-grid-cart>
      `;
    }

    const template = document.createElement('template');

    template.innerHTML = `
      <article
        class="crest-product-card cs-product"
        data-product-id="${escape(p.id)}"
        data-loaded-at="${loadedAt}"
      >
        ${heart}

        <a
          class="cs-image"
          href="${escape(safeURL(p.url))}"
          aria-label="Apri ${escape(p.title)}"
        >
          ${image ? `
            <img
              src="${escape(image)}"
              alt=""
              width="90"
              height="100"
              loading="lazy"
            >
          ` : ''}
        </a>

        <div class="cs-info">
          <small>${escape(p.category || p.type || 'CREST')}</small>
          <h3>
            <a href="${escape(safeURL(p.url))}">
              ${escape(p.short)}
            </a>
          </h3>
          <p>${escape(
            p.benefit ||
            (
              p.category === 'cere'
                ? [p.hold, p.finish].filter(Boolean).join(' · ')
                : p.type
            )
          )}</p>
        </div>

        <div class="cs-buy">${purchase}</div>
      </article>
    `;

    const node = template.content.firstElementChild;
    cards.set(p.id, node);

    return node;
  }

  function draw() {
    if (root.hidden) return;

    updateLink();

    if (busy()) {
      status.textContent = 'Completo l’aggiornamento del carrello…';
      return;
    }

    retry.hidden = !failed;

    if (!catalog || pending) {
      status.textContent = failed
        ? 'Non riesco a caricare il catalogo. Puoi riprovare.'
        : 'Carico il catalogo CREST…';
      return;
    }

    if (failed) {
      status.textContent =
        'Non riesco ad aggiornare il catalogo. Riprova.';
      return;
    }

    const found = catalog
      .map(p => ({ p, score: core.score(p, input.value) }))
      .filter(item => item.score >= 0)
      .sort((a, b) =>
        b.score - a.score ||
        a.p.title.localeCompare(b.p.title, 'it')
      );

    status.textContent =
      found.length +
      (found.length === 1 ? ' prodotto trovato' : ' prodotti trovati') +
      (found.length > 6 ? ' · primi 6 risultati' : '');

    root.querySelector('[data-cs-suggestions]').hidden =
      Boolean(input.value.trim());

    const focused = results.contains(document.activeElement)
      ? document.activeElement
      : null;

    const fragment = document.createDocumentFragment();

    found.slice(0, 6).forEach(item => {
      fragment.append(cardFor(item.p));
    });

    results.replaceChildren(fragment);

    if (focused?.isConnected) {
      focused.focus({ preventScroll: true });
    }

    if (!found.length) {
      results.textContent =
        'Nessun prodotto corrisponde alla ricerca. Prova un nome o un’esigenza diversa.';
    }

    all.textContent = found.length
      ? 'Vedi tutti i ' + found.length + ' risultati nella griglia →'
      : 'Esplora tutti i prodotti →';

    if (!found.length) all.href = config.collection;

    document.dispatchEvent(
      new CustomEvent('crest-pairings:cart-changed')
    );
  }

  async function refresh() {
    const version = ++drawVersion;

    retry.hidden = true;
    failed = false;
    status.textContent = 'Carico il catalogo CREST…';

    try {
      await loadCatalog();
    } catch (error) {
      failed = true;
      status.textContent = error.message || 'Caricamento non riuscito.';
    }

    if (version !== drawVersion || root.hidden) return;
    draw();
  }

  function open(trigger) {
    if (!root.hidden) {
      input.focus({ preventScroll: true });
      return;
    }

    opener = trigger;
    pageX = scrollX;
    pageY = scrollY;
    overflow = document.body.style.overflow;

    root.hidden = false;
    document.body.style.overflow = 'hidden';

    inerted = [...document.body.children].filter(node =>
      node !== root &&
      !node.matches('script,style,.crest-saved-toast') &&
      !node.inert
    );

    inerted.forEach(node => {
      node.inert = true;
    });

    document.querySelectorAll('[data-crest-search-open]').forEach(button => {
      button.setAttribute('aria-expanded', 'true');
    });

    input.focus({ preventScroll: true });
    refresh();
  }

  function close() {
    root.hidden = true;

    inerted.forEach(node => {
      node.inert = false;
    });

    inerted = [];
    document.body.style.overflow = overflow;

    document.querySelectorAll('[data-crest-search-open]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });

    if (opener?.isConnected) {
      opener.focus({ preventScroll: true });
    }

    if (scrollX !== pageX || scrollY !== pageY) {
      window.scrollTo({
        left: pageX,
        top: pageY,
        behavior: 'instant'
      });
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-crest-search-open]');
    if (!trigger) return;

    event.preventDefault();
    open(trigger);
  });

  document.addEventListener('keydown', event => {
    if (root.hidden) return;

    if (
      event.key === 'Escape' &&
      !event.target.closest('.crest-saved-toast')
    ) {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const selectors =
      'a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]';

    const focusables = [
      ...panel.querySelectorAll(selectors),
      ...document.querySelectorAll(
        '.crest-saved-toast:not([hidden]) a,.crest-saved-toast:not([hidden]) button'
      )
    ].filter(node =>
      node.getClientRects().length &&
      !node.closest('[hidden]')
    );

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (
      event.shiftKey &&
      (
        document.activeElement === first ||
        !focusables.includes(document.activeElement)
      )
    ) {
      event.preventDefault();
      last?.focus({ preventScroll: true });
    } else if (
      !event.shiftKey &&
      (
        document.activeElement === last ||
        !focusables.includes(document.activeElement)
      )
    ) {
      event.preventDefault();
      first?.focus({ preventScroll: true });
    }
  });

  root.addEventListener('click', event => {
    if (event.target.closest('[data-cs-close]')) {
      close();
      return;
    }

    if (event.target.closest('[data-cs-retry]')) {
      refresh();
      return;
    }

    const chip = event.target.closest('[data-cs-query]');

    if (chip) {
      input.value = chip.dataset.csQuery;
      draw();
      input.focus({ preventScroll: true });
    }

    if (event.target.closest('[data-cs-clear]')) {
      input.value = '';
      draw();
      input.focus({ preventScroll: true });
    }

    if (event.target.closest('[data-cs-all]') && busy()) {
      event.preventDefault();
      status.textContent = 'Attendi che il carrello sia aggiornato.';
    }
  });

  input.addEventListener('input', () => {
    clearTimeout(timer);
    updateLink();
    timer = setTimeout(draw, 120);
  });

  root.querySelector('[data-cs-form]').addEventListener('submit', event => {
    event.preventDefault();

    if (busy()) {
      status.textContent = 'Attendi che il carrello sia aggiornato.';
      return;
    }

    location.assign(destination(input.value));
  });

  new MutationObserver(() => {
    if (!busy() && !root.hidden) {
      clearTimeout(timer);
      timer = setTimeout(draw, 0);
    }
  }).observe(results, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-busy']
  });

  document.addEventListener('submit', event => {
    const form = event.target;

    if (
      !(form instanceof HTMLFormElement) ||
      form.hasAttribute('data-cs-form')
    ) return;

    const action = new URL(form.action, location.origin);

    if (
      action.pathname !==
      new URL(config.search, location.origin).pathname
    ) return;

    const field = form.elements.namedItem('q');
    if (!field) return;

    event.preventDefault();
    location.assign(destination(field.value));
  }, true);
})();